import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  dateField,
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

export const getFilingInfoFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  textField({ name: 'name', label: 'Filing name', required: true }),
  textareaField({ name: 'description', label: 'Description' }),
  selectField(
    {
      name: 'submission_code',
      label: 'Submission code',
      fieldProps: { disabled: true },
      defaultValue: 'E',
      refTable: 'submission_type',
    },
    referenceTables,
  ),
  selectField(
    {
      name: 'report_code',
      label: 'Report code',
      fieldProps: { disabled: true },
      defaultValue: 'STR',
      refTable: 'report_code',
    },
    referenceTables,
  ),
  textField({ name: 'fiu_ref_number', label: 'FIU reference' }),
  dateField({
    name: 'submission_date',
    label: 'Submission date',
    required: true,
  }),
  textField({
    name: 'rentity_id',
    label: 'Reporting entity ID',
    required: true,
  }),
  textField({
    name: 'rentity_branch',
    label: 'Reporting entity branch',
    required: true,
  }),
  textField({
    name: 'entity_reference',
    label: 'Entity reference',
    required: true,
  }),
  selectField(
    {
      name: 'currency_code_local',
      label: 'Local currency code',
      required: true,
      refTable: 'currency_code',
    },
    referenceTables,
  ),
  textareaField({ name: 'reason', label: 'Reason', required: true }),
  textareaField({ name: 'action', label: 'Actions taken' }),
];
